import { Injectable } from '@angular/core';
import { StudentProfileInfo } from '../models/student-profile-info';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { AppSettings } from '../../../../utils/app-settings';
import { map } from 'rxjs/operators';
import { StudentReligions } from '../models/student-religion';
import { StudentCastes } from '../models/student-caste';

@Injectable()
export class StudentProfileService {

  constructor(private http: HttpClient) { }
  private _studentProfileInfo: ReplaySubject<StudentProfileInfo> = new ReplaySubject<StudentProfileInfo>(1);
  private http_fetched = false;

  getProfileInfo(disableCache:boolean=false): Observable<StudentProfileInfo> {
    if (!this.http_fetched || disableCache) {
      this.http_fetched = true;
      this.http.get<StudentProfileInfo>(AppSettings.apiUrl + "students/student-profile-info")
        .subscribe((res) => {
          this._studentProfileInfo.next(res);
        },
          (error) => {
            console.error(error);
            this.http_fetched = false;
          }
        );
    }
    return this._studentProfileInfo.asObservable();
  }

  editStudentProfile(editedProfile: StudentProfileInfo) {
    return this.http.put(`${AppSettings.apiUrl}students/${editedProfile.student_info.student_id}`, editedProfile)
      .pipe(map(res => { return res }));
  }

  updateProfilePhoto(personId: number, blobContentType: number, fileId: number): Observable<any> {
    return this.http.post(AppSettings.apiUrl + "image", { "person_id": personId, "blob_content_type": blobContentType, "file_id": fileId })
  }

  getStudentReligions(): Observable<Array<StudentReligions>> {
    return this.http.get<Array<StudentReligions>>(AppSettings.apiUrl + "users/getallreligions");
  }
  getStudentCastes(religionId: number): Observable<Array<StudentCastes>> {
    return this.http.get<Array<StudentCastes>>(`${AppSettings.apiUrl}users/getcastes/${religionId}`);
  }
}
